export default (state) => state.requestInfos.requests
